

import React, {useState, useRef} from 'react';
import { Link as RouterLink, useNavigate, useLocation} from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormHelperText,
  Link,
  TextField,
  Typography,
  makeStyles,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress
} from '@material-ui/core';
import Page from 'src/components/Page';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash/throttle';
import Firebase from 'src/Firebase';
import DataFetcher from 'src/DataFetcher';
import QuoteStatus from 'src/QuoteStatus';
import HoverMarker from 'src/HoverMarker';
import GoogleMapReact from 'google-map-react';
import JobMasterView from 'src/utils/JobMasterView';
import TransporterTableMainView from '../../custom/TransporterTableMainView';
var moment = require('moment');

const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: theme.palette.background.dark,
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(3),
    }
  }));
  

const EditJobAssignAdmin = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const {state} = useLocation();
    const [isAuthenticating, setIsAuthenticating] = React.useState(0);
    const [transporterCustomPrice, setTransporterCustomPrice] = React.useState(0);


    function doSubmit(values, lst, lett) {
        setIsAuthenticating(true)
        console.log(values)
        console.log(Firebase.userInfo)
    
        var v = values 
        v['quoteId'] = state.customer.quoteId
        //alert(v['transporterPrice'])
        setTransporterCustomPrice(v['transporterPrice'])
        //alert(transporterCustomPrice)
        let suc = function () {
          setIsAuthenticating(2)
          //navigate(-1)
          //window.open(Firebase.adminip + 'v/' + state.customer.quoteId)
        }
    
        let f  = function () {
          setIsAuthenticating(0)
          alert('Error saving changes. Check internet connection and try again.')
        }
    
        Firebase.editQuoteAuth(v, lst, lett, Firebase.uid, suc, f)
    
    
      }

      if (isAuthenticating == 1) {
        return (<Page
          className={classes.root}
          title="Request Quote"
          backgroundColor={classes.root.backgroundColor}
        ><div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}><CircularProgress/></div></Page>)
      } else if (isAuthenticating == 2) {
        return (
          <TransporterTableMainView transporterPrice={transporterCustomPrice} location={state.customer} onComplete={() => navigate(-1)} />
        );
      }
      return (<JobMasterView editQuoteShipper={false} transporterAssignment={true} adminEdit={true} provideQuote={false} privateQuote={false} publicQuote={false} quoteOffer={false} evaluateBid={false} parentSubmit={(v, ls, le) => doSubmit(v, ls, le)} parentState={state} jobProps={{editable: false, priceEditable: true, showPrices: true, showAssignments: false, showTransporterPrice: true, transporterPriceEditable: true}} />)
    

};

/*

        

*/

export default EditJobAssignAdmin;